/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Model_Price_UnavailableInputs */



/**
* | output |
* | --- |
* | "Pricing not yet published" |
*
* @param {Uno_Settings_Model_Price_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_model_price_unavailable = /** @type {((inputs?: Uno_Settings_Model_Price_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Model_Price_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Preise noch nicht veröffentlicht")
	return /** @type {LocalizedString} */ ("Pricing not yet published")
});